<template>
  <div>
    <div class="survey-module">
      <div class="common-container justify-between">
        <div class="survey-module-right">
          <div class="survey-module-right-title f-w">
            {{detail_name}} - 文章详情
          </div>
          <div class="survey-module-right-action">
            <div v-if="menu_action" v-html="menu_action"></div>
            <el-empty class="survey-module-right-action-empty" v-else description="暂无内容"></el-empty>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getdetail1,getdetail2 } from '@/api/detail';
export default {
  data(){
    return{
      menu_action:'',
      detail_name:this.$route.query.name
    }
  },
  created(){
    this.getInfo()
  },
  methods:{
    getInfo(){
      // console.log(this.$route.query.detail_id);
      if(this.$route.query.type==1){
        getdetail1({id:this.$route.query.detail_id}).then((res)=>{
          this.menu_action = res.data.richText
          this.menu_action = this.menu_action.replace(/<img/g, "<img style='max-width:100%;height:auto;'")
          this.menu_action = this.menu_action.replace(/<video/g, "<video style='max-width:100%;height:auto;'")
        })
      }else{
        getdetail2({id:this.$route.query.detail_id}).then((res)=>{
          this.menu_action = res.data.richText
          this.menu_action = this.menu_action.replace(/<img/g, "<img style='max-width:100%;height:auto;'")
          this.menu_action = this.menu_action.replace(/<video/g, "<video style='max-width:100%;height:auto;'")
        })
      }
      
    }
  }
}
</script>
<style scoped lang="css" src="../assets/css/rem.css" />
